// 对axios进行封装
import axios from 'axios'
import store from '../store/index'
import { removeUser } from '@/utils/auth'

// axios全局配置
axios.defaults.baseURL = window.location.origin
axios.defaults.withCredentials = true
export default class nswHttp {
	static httpSend(options) {
		options.url = options.url.replace(/^(\/lavrock)(.*)/g, function($1, $2, $3) {
			return $3
		})
		//请求头统一添加user_token，用于Q云免密登录
		const token = store.state.user.user ? store.state.user.user.token : 0
		axios.defaults.headers.common['userToken'] = token
		return new Promise((resolve, reject) => {
			axios(options)
				.then(res => {
					resolve(res)
				})
				.catch(err => {
					if (err.response.status === 401) {
						store.commit('SET_CONFIRM_LOGIN', true)
						removeUser()
					}
					reject(err)
				})
		})
	}
	static httpGet(url, params) {
		return this.httpSend({
			method: 'get',
			url: url,
			params: params
		})
	}

	static httpPost(url, data, params) {
		return this.httpSend({
			method: 'post',
			url: url,
			data: data,
			params: params
		})
	}

	static httpPut(url, data, params) {
		return this.httpSend({
			method: 'put',
			url: url,
			data: data,
			params: params
		})
	}

	static httpDelete(url, params) {
		return this.httpSend({
			method: 'delete',
			url: url,
			params: params
		})
	}

	static getBaseUrl() {
		return axios.defaults.baseURL
	}
}
